/**
 * @registry Shared sentinels and value sets for the job Documents module and the
 * Settings folder templates: ROOT_FOLDER_ID is the id the folder trees use for the
 * synthetic job-root node (the API takes no folder id at the root), and the access /
 * folder-type sets mirror the values the DocumentController validates.
 */
export const ROOT_FOLDER_ID = 'documents';

export const DOCUMENT_ACCESS = {
  all: 'all',
  onlyYou: 'only_you',
  people: 'people',
} as const;

export type DocumentAccess =
  typeof DOCUMENT_ACCESS[keyof typeof DOCUMENT_ACCESS];

export const DOCUMENT_FOLDER_TYPE = {
  standard: 'standard',
  emails: 'emails',
} as const;

export type DocumentFolderType =
  typeof DOCUMENT_FOLDER_TYPE[keyof typeof DOCUMENT_FOLDER_TYPE];

export const isRestrictedAccess = (access?: string | null): boolean =>
  access === DOCUMENT_ACCESS.people || access === DOCUMENT_ACCESS.onlyYou;
